import React from 'react';

export default function Welcome(props) {
  return (
    <section className="section auth">
      <div className="container">
        <h1>Hola!</h1>
        <p>Tu registro fue exitoso.</p>
        <button onClick={() => {
          props.history.push('/login')
        }}>Inicio de Sesión</button>
      </div>
    </section>
  )
}
